import KeyMirror from 'keymirror'

export const CLIENT_BILLING_FORM_NAMES = KeyMirror({
  clientId: null,
  longName: null,
  shortName: null,
  description: null,
  feeOverride: null,
  feeScheduleType: null,
  profilePicMediaId: null,
  clientAbbreviation: null,
  tags: null
})

export const mapFeeSchedule = (feeSchedule) => {
  return {
    id: feeSchedule.feeScheduleId,
    name: feeSchedule.longName,
    description: feeSchedule.description,
    details: Object.values(
      feeSchedule.details.reduce(
        (acc, feeDetail) => ({
          ...acc,
          [feeDetail.calcTypeId]: [
            ...(acc[feeDetail.calcTypeId] || []),
            {
              rate: feeDetail.feeRate,
              denomination: feeDetail.denomination,
              limits: {
                lower: feeDetail.lowerLimit,
                upper: feeDetail.upperLimit
              },
              calcTypeId: feeDetail.calcTypeId
            }
          ]
        }),
        {}
      )
    )
  }
}
